<template>
<div class="layout-sidebar" :class="{'layout-sidebar--collapse':isCollapse}">
  <div class="layout-sidebar__logo">
    <a href="/">
      <icon type="logo" />
    </a>
  </div>

  <div
    :title="t('layouts.sidebarHanlde')"
    class="layout-sidebar__handle"
    @click="isCollapse = !isCollapse">
    <icon
      :type="isCollapse ? 'right' : 'left'"
      :size="12"
    />
  </div>

   <ui-menu
      class="layout-menu"
      :collapse="isCollapse"
      v-model="activeIndex"
      unique-opened
      @select="handleSelect"
      :default-openeds="activeIds">
      <template>
        <component
          :is="selectMenuComponent(menu)"
          v-for="menu of menuList"
          :key="menu.id"
          class="level-1"
          :class="{active: isActiveMenu(menu.id)}"
          :showTimeout="DELAY_TIME"
          :hideTimeout="DELAY_TIME"
          :index="menu.id">
          <template v-if="!menu.subMenu">
            <ui-badge
              v-if="menu.showBadge"
              slot="icon"
              value="1"
              dot>
              <i
                :class="`common-iconfont-${menu.icon}`"
                class="icon common-iconfont" />
            </ui-badge>
            <i
              v-else
              slot="icon"
              :class="`common-iconfont-${menu.icon}`"
              class="icon common-iconfont" />
            <a
              :href="menu.url"
              slot="title"
              class="menu-link"
              @click.prevent>
              {{ menu.name }}
            </a>
          </template>
          <template v-if="menu.subMenu">
            <ui-badge
              v-if="menu.showBadge"
              slot="icon"
              value="1"
              dot>
              <i
                :class="`common-iconfont-${menu.icon}`"
                class="icon common-iconfont" />
            </ui-badge>
            <i
              v-else
              slot="icon"
              :class="`common-iconfont-${menu.icon}`"
              class="icon common-iconfont" />
            <span slot="title" v-if="menu.subMenu">
              {{ menu.name }}
            </span>
            <component
              :is="selectMenuComponent(subMenu)"
              :class="{active: isActiveMenu(subMenu.id)}"
              :index="subMenu.id"
              v-for="subMenu of menu.subMenu"
              v-show="isShowMneu(subMenu)"
              class="level-2"
              :showTimeout="DELAY_TIME"
              :hideTimeout="DELAY_TIME"
              :key="subMenu.id">
              <i
                slot="icon"
                :class="`common-iconfont-${subMenu.icon}`"
                class="icon common-iconfont" />
              <a
                v-if="!subMenu.subMenu"
                :href="subMenu.url"
                slot="title"
                class="menu-link"
                @click.prevent>
                {{ subMenu.name }}
                <ui-tag v-if="subMenu.activity" radius size="mini" :bordered="false" background-color="#e95b5b" color="#fff">{{ t('menu.focusTips') }}</ui-tag>
              </a>
              <template v-if="subMenu.subMenu">
                <span slot="title" v-if="subMenu.subMenu">
                  {{ subMenu.name }}
                </span>
                <component
                  :is="selectMenuComponent(itemMenu)"
                  :class="{active: isActiveMenu(itemMenu.id)}"
                  :index="itemMenu.id"
                  v-for="itemMenu of subMenu.subMenu"
                  class="level-3"
                  :showTimeout="DELAY_TIME"
                  :hideTimeout="DELAY_TIME"
                  :key="itemMenu.id">
                  <i
                    slot="icon"
                    :class="`common-iconfont-${itemMenu.icon}`"
                    class="icon common-iconfont" />
                  <a
                    :href="itemMenu.url"
                    slot="title"
                    class="menu-link"
                    @click.prevent>
                    {{ itemMenu.name }}
                  </a>
                </component>
              </template>
            </component>
          </template>
        </component>
      </template>
    </ui-menu>
</div>
</template>

<script>
import { Menu, MenuItem, MenuItemGroup, Submenu, Badge, Tag } from 'amumu-ui';
import Icon from '../components/icon';
import menuTree from './menuTree';
import { filterMenuList, forEachMenuList } from '../utils';
import i18nHandle from '../locales';
import { checkPermission, checkAndPermission } from '../utils/permission';

const SIDEBAR_STATE_KEY = 'sidebarState';

const DEFAULT_SIDEBAR_STATE = {
  COMMON: 1,
  MAIL: 1,
};

const AI_NO_MENU_INFO = {
  id: 'ai',
  icon: 'ai',
  system: 'PERSON',
  url: '/ai',
  urlInfo: ['_blank'],
  roles: ['crm.functional.base'],
};

const CRM_COQ_MENU_INFO = {
  id: 'ciqDatum',
  system: 'CRM',
  url: '/ciq',
  roles: ['crm.functional.base'],
};

const DELAY_TIME = 100;

const BADGE_STATE_KEY = 'menuBadgeStateKey';

const get = (url, data = {}) =>
  fetch(`${process.env.SERVERS.CRM}/api${url}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'include',
  }).then(response => response.json());

export default {
  components: {
    'ui-menu': Menu,
    'ui-menu-item': MenuItem,
    'ui-menu-item-group': MenuItemGroup,
    'ui-submenu': Submenu,
    'ui-badge': Badge,
    'ui-tag': Tag,
    Icon,
  },
  props: {
    system: {
      type: String,
      default: '',
    },
    privilege: {
      type: Object,
      default: () => ({}),
    },
    setting: {
      type: Object,
      default: () => ({}),
    },
    onCreateMenu: {
      type: Function,
      default: menu => menu,
    },
  },
  data() {
    return {
      DELAY_TIME,
      activeIndex: null,
      isCollapse: true,
      sidebarState:
        JSON.parse(localStorage.getItem(SIDEBAR_STATE_KEY)) ||
        DEFAULT_SIDEBAR_STATE,
      showBadgeIds: [],
      showActivityIds: [],
    };
  },
  computed: {
    menuList() {
      const isTW = window.location.host.includes('okki.com');
      let HOSTS = process.env.HOSTS;
      if (isTW) {
        HOSTS = Object.keys(HOSTS).reduce((prev, key) => {
          prev[key] = HOSTS[key].replace('xiaoman.cn', 'okki.com');
          return prev
        }, {});
      }

      const menuList = filterMenuList({
        menuList: this.dealModules(menuTree),
        privilege: this.privilege,
        setting: this.setting,
        system: this.system,
        hostMap: HOSTS,
      });
      forEachMenuList(menuList, menu => {
        this.onCreateMenu(menu);
      });
      return menuList;
    },
    flatMenuObject() {
      const flatMenuObject = {};
      forEachMenuList(this.menuList, menu => {
        flatMenuObject[menu.id] = menu;
      });
      return flatMenuObject;
    },
    activeIds() {
      const activeIds = [];
      Object.values(this.flatMenuObject).forEach(menuItem => {
        const { system, $router, $route } = this;
        const { url, id, system: menuSystem, parentMenu } = menuItem;
        // system相同、解析的url相同 或者 路由的meta里硬编码了要高亮的id
        const isActive =
          (!!url &&
            system === menuSystem &&
            $router.resolve(url).resolved.name ===
              $router.resolve($route.path).resolved.name) ||
          $route.meta.menuId === id;
        if (isActive) {
          activeIds.push(id);
          if (parentMenu && parentMenu.length) {
            activeIds.unshift(...parentMenu);
          }
        }
      });
      return activeIds;
    },
    activeModules() {
      return window.location.href.indexOf('/pro/mail') > -1 ? 'MAIL' : 'COMMON';
    },
  },
  watch: {
    isCollapse() {
      this.sidebarState[this.activeModules] = Number(this.isCollapse);
      localStorage.setItem(
        SIDEBAR_STATE_KEY,
        JSON.stringify(this.sidebarState),
      );

      this.updateCollapsedFlag();
    },
  },
  created() {
    this.isCollapse = !!this.sidebarState[this.activeModules];
    this.updateCollapsedFlag();
    // this.checkActivityAndBadge();
  },
  methods: {
    isShowMneu(menu) {
      return Array.isArray(menu.subMenu) ? menu.subMenu.length : true;
    },
    updateCollapsedFlag() {
      document.documentElement.classList[this.isCollapse ? 'add' : 'remove'](
        'is-menu-collapsed',
      );
    },
    isActiveMenu(id) {
      return this.activeIds.includes(id);
    },
    dealModules(list) {
      const { showBadgeIds = [], showActivityIds = [] } = this;
      const hasAiModule = checkPermission('crm.functional.ai', this.privilege);
      return list.map(item => {
        // 主菜单显示红点
        if (
          showBadgeIds.length &&
          showBadgeIds.includes(item.id) &&
          !localStorage.getItem(`${BADGE_STATE_KEY}-${item.id}`)
        ) {
          item.showBadge = true;
        }

        // 子菜单显示“限时活动”标签
        if (item.subMenu && showActivityIds.length) {
          item.subMenu.map(sub => {
            if (showActivityIds.includes(sub.id)) {
              sub.activity = true;
            }
            return sub;
          });
        }

        // AI如果没有权限，则去推荐页面
        if (item.id === 'ai' && !hasAiModule) {
          return AI_NO_MENU_INFO;
        }

        // 海关数据优先选择 dx 没有权限显示crm
        if (item.id === 'mk') {
          const subMenu = item.subMenu.map(sub => {
            if (sub.id === 'ciqDatum') {
              const value = !Array.isArray(sub.roles)
                ? sub.roles && sub.roles.value
                : sub.roles;

              if (!checkAndPermission(value, this.privilege)) {
                return CRM_COQ_MENU_INFO;
              }
            }
            return sub;
          });
          return {
            ...item,
            subMenu,
          };
        }
        return item;
      });
    },
    changeMenu(menu) {
      const parentMenu = menu.parentMenu[0];
      const { showBadgeIds = [] } = this;
      if (showBadgeIds.includes(parentMenu)) {
        localStorage.setItem(`${BADGE_STATE_KEY}-${parentMenu}`, true);
      }
      this.activeIndex = menu.id;
      if (menu.system === this.system) {
        this.$router.push(menu.url);
      } else {
        const urlInfo = menu.urlInfo || ['_self'];
        window.open(menu.url, ...urlInfo);
      }
    },
    selectMenuComponent(list) {
      if (list.subMenu) {
        return 'ui-submenu';
      }
      return 'ui-menu-item';
    },
    handleSelect(id) {
      this.changeMenu(this.flatMenuObject[id]);
    },
    t: i18nHandle.t,
    checkActivityAndBadge() {
      const checkBadgeStatus = get('/paypalPaymentRead/showActivityBanner');
      checkBadgeStatus.then(({ data: { activity_type } }) => {
        if (Number(activity_type) === 0) {
          return;
        }
        this.showBadgeIds = ['cpq'];
        this.showActivityIds = ['paypalBill'];
      });
    },
  },
};
</script>

<style lang="scss">
$scrollbarColor: #4d4d4d;
$backgroundColor: #313131;

.layout-sidebar {
  $root: &;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  box-shadow: 0 -1px 4px 0 #000302;
  background: $backgroundColor;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: $backgroundColor;
    border-radius: 8px;
  }

  ::-webkit-scrollbar-track {
    background: $backgroundColor;
  }

  &:hover {
    ::-webkit-scrollbar-thumb {
      background: $scrollbarColor;
    }
  }

  &--collapse {
    padding-right: 0;

    #{$root}__logo {
      padding: 12px 0 0 10px;
    }
  }

  &__logo {
    transition: 0.3s;
    padding: 10px 0 5px 15px;

    i {
      transition: 0.3s;
      font-size: 36px;
      color: #fff;
      opacity: 0.7;
    }
  }

  &__handle {
    position: absolute;
    top: 18px;
    right: -12px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
    border-radius: 50%;
    background: #63686e;
    .common-iconfont {
      color: #fff;
    }
    &:hover {
      background: #0884f3;
    }
  }

  // 需要从AMUMU里定制主题
  .layout-menu {
    flex: 1;
    border-right: none;
    background: $backgroundColor;
    overflow-x: hidden;
    overflow-y: auto;
    user-select: none;

    &:not(.mm-menu--collapse) {
      width: 250px;
    }

    &.v-enter-active,
    &.v-leave-active {
      .mm-menu-title {
        transition: opacity 0.3s;
        opacity: 1;
        will-change: opacity;
      }
    }

    &.v-enter-to,
    &.v-leave-to {
      .mm-menu-title {
        opacity: 0;
      }
    }

    .mm-menu-item-group .mm-menu-item-group-title,
    .mm-submenu-title,
    .menu-link,
    .mm-menu-item {
      color: rgba(255, 255, 255, 0.7);
      transition: 0.3s color;

      &:hover,
      &:hover .common-iconfont {
        color: #fff;
      }
    }

    .mm-menu-item:hover,
    .mm-menu-item:focus,
    .mm-submenu-title:hover,
    .mm-submenu-title:focus {
      background-color: initial !important;
    }

    .mm-menu-item.active {
      background-color: #0584f3 !important; // amumu里也写了 important Orz

      .common-iconfont,
      .menu-link,
      .mm-menu-title,
      .icon.common-iconfont {
        color: #fff;
      }
    }
  }
  .menu-link {
    display: inline-block;
    width: 100%;
  }

  .icon.common-iconfont {
    font-size: 18px;
    color: #b4b8c3;
  }

  .mm-submenu-title .mm-submenu-icon-arrow {
    color: #fff;
  }

  // 各级菜单，没有合适的标识，强行处理
  .mm-menu-item,
  .mm-submenu-title {
    padding: 0 !important;
    height: 45px;
    line-height: 45px;

    .mm-menu-icon {
      padding: 0;
    }
  }

  @for $i from 1 through 3 {
    .level-#{$i} {
      &.mm-menu-item,
      &.mm-submenu {
        .mm-menu-icon {
          padding-left: #{$i * 25}px !important;
        }
      }
    }
  }

  .mm-submenu {
    .mm-menu,
    .mm-menu-item,
    .mm-submenu {
      background-color: #373737 !important;
    }

    &.mm-submenu--opened,
    &.active {
      > .mm-submenu-title {
        .icon.common-iconfont,
        .mm-menu-title,
        .mm-submenu-icon-arrow {
          color: #4c92ff;
        }
      }

      &:hover {
        .mm-submenu-title {
          background-color: initial !important;
        }
      }
    }
  }

  // 折叠系列
  @at-root .mm-tooltip-popper .menu-link {
    color: #fff;
  }

  @at-root .mm-menu-popper {
    max-height: 450px;
    overflow: auto;
    transition-duration: 0.15s;
    position: relative;
    z-index: 2000;

    .mm-menu-icon {
      display: none;
    }

    .mm-menu {
      background-color: $backgroundColor;
      padding: 0;
      border-radius: 6px;
      overflow: hidden;
    }

    .mm-submenu {
      &.mm-submenu--opened {
        .mm-submenu-title,
        .mm-menu-title,
        .mm-submenu-icon-arrow,
        .menu-link {
          color: #fff;
        }
      }
    }

    .mm-submenu-title,
    .mm-menu-item {
      height: 45px;
      line-height: 45px;
      padding: 0 24px !important;
    }

    .mm-submenu-title,
    .mm-submenu-icon-arrow,
    .menu-link {
      color: #b4b8c3;
      transition: 0.3s color;
    }

    .mm-submenu-title:hover,
    .mm-menu-item:hover,
    .mm-menu-item:focus {
      background-color: darken($backgroundColor, 8%) !important;

      .mm-menu-title,
      .mm-submenu-icon-arrow,
      .menu-link {
        color: #fff;
      }
    }

    .mm-menu-item.active {
      background-color: #0584f3 !important;
      .menu-link {
        color: #fff;
      }
    }
  }
}
</style>
